document.addEventListener("DOMContentLoaded", function () {

  let demoFormObserver;

  function trackDemoFormVisibility() {
    demoFormObserver?.disconnect();
    const buttons = document.querySelectorAll('.block__header_book-demo-btn');
    const form = document.getElementById('demo-conversion-form');
    function releaseInitialState() {
      document.getElementById('lp-demo-button-initial-state')?.remove();
    }
    function revealAfterCheck(button) {
      if (button.hasAttribute('data-demo-visibility-pending')) {
        button.style.removeProperty('display');
        button.removeAttribute('data-demo-visibility-pending');
      }
    }
    if (!form || !buttons.length) {
      buttons.forEach(button => {
        button.classList.remove('demo-form-in-view');
        revealAfterCheck(button);
      });
      releaseInitialState();
      return;
    }

    demoFormObserver = new IntersectionObserver(entries => {
      const visible = entries.some(entry => entry.isIntersecting && entry.intersectionRatio > 0);
      buttons.forEach(button => {
        button.classList.toggle('demo-form-in-view', visible);
        revealAfterCheck(button);
      });
      releaseInitialState();
    }, { threshold: 0 });
    demoFormObserver.observe(form);
  }

  trackDemoFormVisibility();
  document.addEventListener('shopify:section:load', trackDemoFormVisibility);
  document.addEventListener('shopify:section:unload', trackDemoFormVisibility);

  const openBtns = document.querySelectorAll(".open-video-popup");
  const popup = document.querySelector(".video-popup");
  const closeBtn = document.querySelector(".close-video");
  const video = document.getElementById("globalVideo");
  const source = document.getElementById("videoSource");

  // Only add event listeners if popup exists
  if (popup) {

    openBtns.forEach(btn => {
      btn.addEventListener("click", function () {

        const videoUrl = this.getAttribute("data-video-url");

        if (videoUrl && source) {
          source.src = videoUrl;

          video.load();

          video.onloadeddata = () => {
            video.play();
          };
        }

        popup.classList.add("active");
        document.body.classList.add("overflow-hidden");
      });
    });

    function closePopup() {
      popup.classList.remove("active");
      document.body.classList.remove("overflow-hidden");

      if (video) {
        video.pause();
        video.currentTime = 0;
        source.src = "";
      }
    }

    if (closeBtn) {
      closeBtn.addEventListener("click", closePopup);
    }

    popup.addEventListener("click", function (e) {
      if (e.target.classList.contains("video-popup-overlay")) {
        closePopup();
      }
    });
  }

  // IntersectionObserver part
  const elements = document.querySelectorAll('.animate-left, .animate-right, .animate-up');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate-show');
      }
    });
  }, {
    threshold: 0.2
  });

  elements.forEach(el => observer.observe(el));

});
